<template>
  <div>
    <div class="col-12">
      <div class="row">
        <div class="col-12 py-3 px-0">
          <h3 class="mt-0 mb-2 text-title-dashboard my-2 font-weight-bold">
            Pagos verificados
          </h3>
          <div class="row">
            <div class="form-group col-12 col-xl-10 mb-0 mb-md-4 px-0">
              <div class="row">
                <div class="col-12 col-lg-4 px-2">
                  <label for="company" class="px-1">Agremiado</label>
                  <Multiselect
                    class="mt-1 mb-2 px-1"
                    v-model="selectedCompany"
                    :options="companies"
                    label="name"
                    placeholder="Seleccionar agremiado"
                    :show-labels="false"
                    id="company"
                    @input="loadElements(currentPage, id_user_balance)"
                  ></Multiselect>
                </div>
                <div class="col-6 col-lg-2 mt-1 pl-0 pl-lg-3 pr-0 div-select">
                  <label for="startDate" class="px-1">Desde</label>
                  <input
                    type="date"
                    class="form-control mt-1 mb-2"
                    id="startDate"
                    v-model="startDate"
                    @change="loadElements(currentPage, id_user_balance)"
                    style="border-color: #ced4da; border-radius: 0.25rem;"
                  />
                </div>
                <div class="col-6 col-lg-2 mt-1 pl-3 pr-0 div-select">
                  <label for="endDate" class="px-1">Hasta</label>
                  <input
                    type="date"
                    class="form-control mt-1 mb-2"
                    id="endDate"
                    v-model="endDate"
                    @change="loadElements(currentPage, id_user_balance)"
                    style="border-color: #ced4da; border-radius: 0.25rem;"
                  />
                </div>
                <div class="col-6 col-lg-2 mt-1 pl-0 pl-lg-3 pr-0 div-select">
                  <label for="">Tipo </label>
                  <Multiselect
                    v-model="selectedTypePayment"
                    :options="typePayments"
                    label="name"
                    placeholder="Tipo"
                    :show-labels="false"
                    id="typePayment"
                    @input="loadElements(currentPage, id_user_balance)"
                  ></Multiselect>
                </div>
                <div class="col-6 col-lg-2 mt-1 pl-0 pl-lg-3 pr-0 div-select">
                  <div v-if="id_user_balance">
                    <label for="">Estado </label>
                    <Multiselect
                      v-model="queryStatus"
                      style="width: 95%"
                      :options="status"
                      label="name"
                      placeholder="Estado"
                      :show-labels="false"
                      id="typeStatus"
                      @input="loadElements(currentPage, id_user_balance)"
                    ></Multiselect>
                  </div>
                  <div v-else>
                    <label class="d-block">&nbsp;</label>
                    <button
                      class="btn px-2 d-flex align-items-center border-primary mt-1"
                      style="height: 42px"
                      @click="resetQuery()"
                    >
                      <i class="bi bi-eraser-fill text-primary"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-xl-2 p-0 mb-3 pt-md-0 pl-xl-4 pl-0">
              <div class="pt-0 pl-md-1 pl-0" style="gap: 5px">
                <button
                  v-if="false"
                  type="button"
                  class="col-12 text-white mb-0 mt-md-0 mt-2 bg-primary border-0 mr-0 btn"
                  @click="goNewPayment"
                >
                  Crear Pago
                </button>
                <button
                  v-if="!id_user_balance"
                  type="button"
                  class="col-12 text-white mt-2 bg-primary border-0 ml-0 btn mr-2"
                  @click="openAnalyticsModal"
                >
                  Analíticas
                </button>
                <button
                  v-if="!id_user_balance"
                  type="button"
                  class="col-12 text-white mt-2 bg-primary border-0 ml-0 btn"
                  @click="goNewCollection"
                >
                  Crear Cobro
                </button>
              </div>
            </div>
          </div>

          <div class="table-responsive card overflow-auto">
            <table class="table table-sm table-hover">
              <thead class="thead-light">
                <tr>
                  <th class="text-center" scope="col">
                    <div class="font-weight-bold text-center">Orden</div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">ID</div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">
                      Fecha de pago
                    </div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">Título</div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">Tipo</div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">Agremiado</div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">Banco</div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">
                      Monto de cobro
                    </div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">Monto pagado</div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">Estatus</div>
                  </th>
                  <th class="mb-0" scope="col">
                    <div class="font-weight-bold text-center">Acciones</div>
                  </th>
                  <th class="d-none"></th>
                </tr>
              </thead>
              <tbody class=" ">
                <tr v-for="item in payments" :key="item.reference">
                  <td class="text-center">
                    <span
                      class="rounded-lg w-100 py-1 d-flex justify-content-center text-white"
                      style="background-color: #1863e573"
                      >{{ item.order }}</span
                    >
                  </td>
                  <td class="text-center">{{ item.id }}</td>
                  <td class="text-center">
                    {{
                      item.payment_date === 'Invalid DateTime' ||
                      item.payment_date === null
                        ? ''
                        : item.payment_date.split('-').reverse().join('/')
                    }}
                  </td>
                  <td class="text-center">{{ item.title }}</td>
                  <td class="text-center">
                    {{ item.type_payment ? item.type_payment.name : '' }}
                  </td>
                  <td class="text-center">{{ item.company.company_name }}</td>
                  <td class="text-center">
                    {{
                      item.payment_bank_name !== 'null'
                        ? item.payment_bank_name
                        : ''
                    }}
                  </td>
                  <td class="text-center">
                    <span
                      v-if="
                        item.type_currency &&
                        item.type_currency.name === 'Dolar'
                      "
                      >$</span
                    >
                    <span v-else>Bs.</span>
                    {{ item.amount }}
                  </td>
                  <td class="text-center">
                    <span
                      v-if="
                        item.type_currency &&
                        item.type_currency.name === 'Dolar'
                      "
                      >$</span
                    >
                    <span v-else>Bs.</span>
                    {{ item.expected_amount }}
                  </td>
                  <td class="text-center">
                    <span
                      class="badge"
                      :class="{
                        'badge-warning': item.type_payment_status.id === 1,
                        'badge-danger': item.type_payment_status.id === 2,
                        'badge-success': item.type_payment_status.id === 3,
                        'badge-info': item.type_payment_status.id === 4
                      }"
                      >{{ item.type_payment_status.name }}</span
                    >
                  </td>
                  <td class="text-center">
                    <div class="d-flex justify-content-center w-100">
                      <button
                        v-if="false"
                        class="btn bg-primary d-flex justify-content-center align-items-center border-0 mr-1 border-0 p-2"
                        @click="goEdit(item.id)"
                      >
                        <i class="bi bi-pencil text-white"></i>
                      </button>
                      <button
                        v-if="false"
                        class="btn bg-primary d-flex justify-content-center align-items-center border-0 mr-1 border-0 p-2"
                        @click="goDelete(item.id, item.active)"
                      >
                        <i class="bi bi-trash text-white"></i>
                      </button>
                      <button
                        v-if="item.payment_image"
                        class="btn bg-primary d-flex justify-content-center align-items-center border-0 mr-1 border-0 p-2"
                        @click="openImageModal(item.payment_image)"
                      >
                        <i class="bi bi-eye text-white"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <!--Paginacion-->
            <div class="d-flex justify-content-center">
              <nav aria-label="Page navigation example">
                <ul class="pagination">
                  <li
                    class="page-item"
                    :class="{ disabled: currentPage === 1 }"
                  >
                    <a
                      class="page-link"
                      href="#"
                      aria-label="Previous"
                      @click.prevent="changePage(currentPage - 1)"
                    >
                      <span aria-hidden="true">&laquo;</span>
                    </a>
                  </li>
                  <li
                    v-for="page in totalPages"
                    :key="page"
                    class="page-item"
                    :class="{ active: currentPage === page }"
                  >
                    <a
                      class="page-link"
                      href="#"
                      @click.prevent="changePage(page)"
                      >{{ page }}</a
                    >
                  </li>
                  <li
                    class="page-item"
                    :class="{ disabled: currentPage === totalPages }"
                  >
                    <a
                      class="page-link"
                      href="#"
                      aria-label="Next"
                      @click.prevent="changePage(currentPage + 1)"
                    >
                      <span aria-hidden="true">&raquo;</span>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div
      v-if="showImageModal"
      class="modal-overlay"
    >
      <div class="modal-content">
        <img :src="selectedImageUrl" alt="Imagen ampliada" />
        <button
          @click="closeImageModal"
          class="btn btn-danger"
          style="position: absolute; top: 10px; right: 10px"
        >
          Cerrar
        </button>
      </div>
    </div>
    
    <!-- Modal de Analíticas -->
    <div
      v-if="showAnalyticsModal"
      class="modal-overlay"
    >
      <div class="modal-content bg-white p-4" style="width: 80%; max-width: 800px; max-height: 80vh; overflow-y: auto; border-radius: 8px; position: relative;">
        <button
          @click="closeAnalyticsModal"
          class="close-button"
          style="position: absolute; top: 15px; right: 15px; background: none; border: none; font-size: 22px; cursor: pointer; color: #6c757d; z-index: 10;"
        >
          <i class="bi bi-x"></i>
        </button>
        
        <h4 class="mb-4">Analíticas de Pagos Verificados</h4>
        
        <div v-if="loadingAnalytics" class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Cargando...</span>
          </div>
          <p class="mt-3">Cargando datos de analíticas...</p>
        </div>
        
        <div v-else-if="analyticsData" class="analytics-content">
          <div class="card p-3 mb-3 bg-light">
            <h5 class="mb-3">Balance Total</h5>
            <div class="d-flex align-items-center justify-content-center">
              <h3 class="text-primary mb-0">
                <span v-if="analyticsData && typeof analyticsData.total_balance === 'number'">
                  <span class="text-success">$</span> {{ analyticsData.total_balance.toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                </span>
                <span v-else-if="analyticsData && analyticsData.total_balance">
                  <span class="text-success">$</span> {{ analyticsData.total_balance }}
                </span>
                <span v-else>
                  <span class="text-success">$</span> 0.00
                </span>
              </h3>
            </div>
            <div class="mt-4">
              <p class="text-muted">
                <small>Datos filtrados según los criterios seleccionados</small>
              </p>
            </div>
          </div>
        </div>
        
        <div v-else class="text-center py-5">
          <p>No hay datos disponibles</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

// Import MultiSelect
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Swal from 'sweetalert2'
export default {
  props: ['id_user_balance', 'title'],
  data() {
    return {
      routeSegment: '',
      payments: [],
      showImageModal: false,
      selectedImageUrl: null,
      startDate: '',
      endDate: '',
      showAnalyticsModal: false,
      analyticsData: null,
      loadingAnalytics: false,
      status: [],
      typePayments: [],
      selectedTypePayment: '',
      selectedCompany: '',
      companies: [],
      queryStatus: '',
      years: [{ value: '', name: 'Todos' }],
      buttonNewCollectionUrl: 'NewCollection',
      buttonNewPaymentUrl: 'NewMonthlyPaymentRecived',
      buttonEditUrl: 'EditMonthlyPaymentRecived',
      searchQuery: '',
      currentPage: 1,
      totalPages: 0,
      limit: 20
    }
  },
  components: {
    Multiselect
  },
  methods: {
    ...mapActions(['getData']),

    resetQuery() {
      this.selectedCompany = ''
      this.queryStatus = ''
      this.startDate = ''
      this.endDate = ''
      this.searchQuery = ''
      this.selectedTypePayment = ''
      this.loadElements(1, this.id_user_balance)
    },
    
    openAnalyticsModal() {
      this.showAnalyticsModal = true
      this.loadingAnalytics = true
      
      // Construir los parámetros para la llamada a la API
      const params = {
        id_type_payment_status: 3 // Verificado es 3
      }
      
      // Añadir filtro de tipo de pago si está seleccionado
      if (this.selectedTypePayment && this.selectedTypePayment.value) {
        params.id_type_payment = this.selectedTypePayment.value
      }
      
      // Añadir filtro de agremiado si está seleccionado
      if (this.selectedCompany && this.selectedCompany.value) {
        params.id_company = this.selectedCompany.value
      }
      
      // Añadir filtros de fecha si están definidos
      if (this.startDate) {
        params.start_date = this.startDate
      }
      
      if (this.endDate) {
        params.end_date = this.endDate
      }
      
      const form = {
        url: 'analitic/company/balance',
        params: params
      }
      
      this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.analyticsData = response.data
          } else {
            console.error('Error al obtener datos de analíticas:', response)
            this.analyticsData = 'Error al cargar datos'
          }
          this.loadingAnalytics = false
        })
        .catch((error) => {
          console.error('Error en la llamada a la API:', error)
          this.analyticsData = 'Error al cargar datos'
          this.loadingAnalytics = false
        })
    },
    
    closeAnalyticsModal() {
      this.showAnalyticsModal = false
      this.analyticsData = null
    },

    openImageModal(imageUrl) {
      this.selectedImageUrl = imageUrl
      this.showImageModal = true
      document.body.style.overflow = 'hidden'
    },
    closeImageModal() {
      this.showImageModal = false
      this.selectedImageUrl = null
      document.body.style.overflow = ''
    },
    loadTypePayments() {
      const form = {
        url: 'type_payment/all',
        params: {
          active: 1
        }
      }
      this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.typePayments = [
              { value: '', name: 'Todos' },
              ...response.data.map((item) => ({
                value: item.id,
                name: item.name
              }))
            ]
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    loadStatus(id_user_balance = null) {
      const form = {
        url: 'type_payment_status/all',
        params: {
          active: 1
        }
      }
      this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.status = [
              { value: '', name: 'Todos' },
              ...response.data.map((item) => ({
                value: item.id,
                name: item.name
              }))
            ]

            if (!id_user_balance) {
              this.status = this.status.filter(
                (item) => item.name !== 'Verificado'
              )
            }
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    loadCompanies() {
      const form = {
        url: 'company/all',
        params: {
          query: '',
          limit: 1000,
          order_value: 'asc',
          order_key: 'company_name'
        }
      }
      return this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.companies = [
              { value: '', name: 'Todos' },
              ...response.data.map((item) => ({
                value: item.id,
                name: item.company_name
              }))
            ]
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    loadElements(page = 1, id_user_balance = null) {
      const form = {
        url: 'payment/all',
        params: {
          query: this.searchQuery,
          page: page,
          limit: this.limit,
          order_value: 'desc',
          order_key: 'id',
          id_type_payment: this.selectedTypePayment.value,
          id_type_payment_status: id_user_balance
            ? this.queryStatus === ''
              ? '[1,2,3,4]'
              : this.queryStatus.value
            : this.queryStatus === ''
            ? '[3]'
            : this.queryStatus.value,
          id_user: id_user_balance,
          id_company: this.selectedCompany ? this.selectedCompany.value : ''
        }
      }
      
      // Añadir filtros de fecha si están definidos
      if (this.startDate) {
        form.params.start_date = this.startDate
        form.params.date_field = 'payment_date'
      }
      
      if (this.endDate) {
        form.params.end_date = this.endDate
        form.params.date_field = 'payment_date'
      }

      this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            const startOrder = (page - 1) * this.limit + 1
            this.payments = response.data.data.map((payment, index) => ({
              ...payment,
              order: startOrder + index
            }))

            this.currentPage = response.data.meta.current_page
            this.totalPages = response.data.meta.last_page
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    changePage(page) {
      if (page < 1 || page > this.totalPages) return
      this.loadElements(page)
    },

    goNewCollection() {
      this.$router.push({ name: this.buttonNewCollectionUrl })
    },
    goNewPayment() {
      this.$router.push({ name: this.buttonNewPaymentUrl })
    },
    goEdit(id) {
      this.$router.push({ name: this.buttonEditUrl, params: { id: id } })
    }
  },
  async mounted() {
    await this.loadStatus(this.id_user_balance)
    await this.loadTypePayments()
    await this.loadCompanies()
    this.loadElements(1, this.id_user_balance)
  }
}
</script>

<style>
tr:last-child td {
  border-bottom: 1px solid #dee2e6;
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  overflow: auto;
}

.modal-content {
  overflow: hidden;
}

.modal-content img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
</style>
